import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  display: none;

  ${media.iphone67p`
    display: block;
  `}
`;

const Btn = styled.button`
  width: 150px;
  height: 45px;
  margin: 20px auto 50px;
  background: #fff;
  color: #aaaaaa;
  border: 1px solid #eeeeee;
  border-radius: 25px;
  font-family: Lato;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.7px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
    transform: translateY(1px);
  }
`;

const Map = () => {
  const style = {
    width: '100%',
    height: '225px',
    frameBorder: '0',
    border: '0',
    padding: '0 20px'
  }
  return (
    <Wrapper>
      <iframe title="google map" style={style} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3165.6124236818555!2d126.98747617974298!3d37.493471488958036!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xad6897cc6a063b04!2sGBH!5e0!3m2!1sko!2skr!4v1508720188524" allowFullScreen></iframe>
      <a href="https://www.google.co.kr/maps/place/GBH/@37.4934715,126.9874762,17z/data=!4m5!3m4!1s0x0:0xad6897cc6a063b04!8m2!3d37.4939567!4d126.990609" target="_blank" rel="noopener noreferrer"><Btn>VIEW MORE</Btn></a>
    </Wrapper>
  );
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/Contact/Map.js